module.exports = {"510118001":"五津街道","510118002":"普兴街道","510118003":"花桥街道","510118004":"花源街道","510118101":"兴义镇","510118102":"安西镇","510118103":"永商镇","510118104":"宝墩镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510118.json
// module id = 2393
// module chunks = 0